<script setup>
import { sendPayslip, viewSalary } from '@/services/payroll.services';
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer';

export default {
    components: { PDFViewer },
    data() {
        return {
            showModal: false,
            data: null,
            currentElem: null,
            processingPayslip: false,
        };
    },
    methods: {
        async handleViewSalary(elem) {
            console.log('elem: ', elem);
            this.currentElem = elem;
            const { data } = await viewSalary({
                user: elem.id,
                basic_pay: parseInt(elem.basic_pay),
                date: elem.pay_date,
                pay_period_from: elem.pay_period_from,
                pay_period_to: elem.pay_period_to,
                tin: elem.tin,
                sss: elem.sss,
                philhealth: elem.philhealth,
                pag_ibig: elem.pag_ibig,
            });
            this.data = window.URL.createObjectURL(new Blob([data]));
            this.showModal = true;
        },
        async handleSendSalary(elem) {
            this.processingPayslip = true;
            this.currentElem = elem;

            const { data } = await sendPayslip({
                user: this.currentElem.id,
                basic_pay: parseInt(this.currentElem.basic_pay),
                date: this.currentElem.pay_date,
                pay_period_from: this.currentElem.pay_period_from,
                pay_period_to: this.currentElem.pay_period_to,
                tin: this.currentElem.tin,
                sss: this.currentElem.sss,
                philhealth: this.currentElem.philhealth,
                pag_ibig: this.currentElem.pag_ibig,
            });
            console.log('data: ', data);
            this.$Message.success('Successfully Sent Payslip');
            this.showModal = false;

            this.processingPayslip = false;
        },
    },
};
</script>

<template>
    <div>
        <Modal v-model="showModal" fullscreen @on-ok="ok" @on-cancel="showModal = false">
            <p>
                <PDFViewer v-if="data != null" :source="data" style="height: 85vh; width: 95vw" /><Button
                    :loading="processingPayslip"
                    @click="handleSendSalary"
                    style="margin-top: 20px"
                    >Send Payslip</Button
                >
            </p>
        </Modal>
    </div>
</template>

<style scoped lang="scss"></style>
